<app-ds-background-surface
  class="dateCalendarDs__cont"
  [width]="width"
  [height]="height"
  [padding]="padding">
  <app-ds-background-surface
    class="dateCalendarDs__fieldset-cont--{{type}}">
    <div class="dateCalendarDs__fieldset dateCalendarDs__fieldset--{{type}}" *ngIf="hasInputs">
      <div class="dateCalendarDs__fieldset__inputs dateCalendarDs__fieldset__inputs--{{type}}">
        <div *ngIf="inputsVisible?.left"
          class="dateCalendarDs__fieldset__inputs__input--left dateCalendarDs__fieldset__inputs__input--{{type}}"
          [class.unique]="!inputsVisible?.right">
          <app-ds-input-text
            [filled]="leftIsFilled"
            [staticFilled]="true"
            [isReadonly]="true"
            [icon]="calendarIcon"
            [highlight]="fieldIsActivated('left')"
            [placeholder]="inputsPlaceholder?.left ?? ''"
            [label]="inputsLabel?.left ?? ''"
            [isDisabled]="fieldIsDisabled('left')"
            [value]="(selectedDates?.left?.formatted | titlecase) ?? ''"
            (clickEvent)="setField('left')">
          </app-ds-input-text>
        </div>
        <div *ngIf="inputsVisible?.right"
          class="dateCalendarDs__fieldset__inputs__input--right dateCalendarDs__fieldset__inputs__input--{{type}}"
          [class.unique]="!inputsVisible?.left">
          <app-ds-input-text
            [filled]="rightIsFilled"
            [staticFilled]="true"
            [isReadonly]="true"
            [icon]="calendarIcon"
            [highlight]="fieldIsActivated('right')"
            [placeholder]="inputsPlaceholder?.right ?? ''"
            [label]="inputsLabel?.right ?? ''"
            [isDisabled]="fieldIsDisabled('right')"
            [value]="(selectedDates?.right?.formatted | titlecase) ?? ''"
            (clickEvent)="setField('right')">
          </app-ds-input-text>
        </div>
      </div>
      <div class="dateCalendarDs__fieldset__content">
        <ng-content></ng-content>
      </div>
    </div>
  </app-ds-background-surface>
  <div class="dateCalendarDs__slider dateCalendarDs__slider--{{type}}">
    <ng-container *ngIf="canMoveCalendar">
      <div class="move-control">
        <ng-container *ngIf="canMoveToLeft">
          <app-ds-button-icon
            class="prev"
            [icon]="prevIcon"
            [buttonSize]="buttonIconSize"
            [iconSize]="20"
            (click)="moveControl(true)">
          </app-ds-button-icon>
        </ng-container>
        <ng-container *ngIf="canMoveToRight">
          <app-ds-button-icon
            class="next"
            [icon]="nextIcon"
            [buttonSize]="buttonIconSize"
            [iconSize]="20"
            (click)="moveControl(false)">
          </app-ds-button-icon>
        </ng-container>
      </div>
    </ng-container>
    <div #monthsViewRef class="dateCalendarDs__slider__months dateCalendarDs__slider__months--{{type}}" [ngStyle]="{
      transform: 'translateX(' + translate  + 'px)'
    }">
      <ng-container *ngFor="let month of months; first as isFirts; last as isLast">
        <div class="month" [class.first]="isFirts" [class.last]="isLast">
          <app-ds-calendar
            [month]="month"
            (clickEvent)="selectDate($event)">
          </app-ds-calendar>
        </div>
      </ng-container>
    </div>
  </div>
</app-ds-background-surface>